import { IMicrositeRecipientForList } from '@nkr/models/microsites';
import { MicrositeRecipientStatus } from '@nkr/enums/microsite-recipient-status';

export interface IBulkDeactivate {
    microsite: IMicrositeRecipientForList,
    type: MicrositeRecipientStatus,
    origin: number,
    reason: string,
    receivedFrom: string,
    transplantDate: string,
    valid: boolean
}
